export class OrderItem {
  constructor(item) {
    let { category, price, originalPrice, markupPrice, markupVersion, customizedName } = item;
    this.category = category;
    this.price = price;
    this.originalPrice = originalPrice;
    this.markupPrice = markupPrice;
    this.markupVersion = markupVersion;
    this.customizedName = customizedName;
    switch(item.category) {
      case "shortcut":
        this.id = item.id;
        this.name = item.shortcutName;
        break;
      case "xChooseY":
        this.id = item.bundleId;
        this.name = item.bundleName;
        this.xChooseYTestIds = item.xChooseYTestIds;
        this.supplementIds = item.supplementIds;
        // TODO: temporarily add selectedZoomerIdList and selectedSupplementIdList for backward compatibility
        // need to remove all usages of selectedZoomerIdList and selectedSupplementIdList in the whole project in the future
        this.selectedZoomerIdList = item.xChooseYTestIds;
        this.selectedSupplementIdList = item.supplementIds;
        break;
      case "discountPanel":
      case "customPanel":
        this.id = item.bundleId;
        this.name = item.bundleName;
        this.testIdsInPanel = item.testIdsInPanel || [];
        break;
      case "va":
      case "vw":
      default:
        this.id = item.id;
        this.name = item.displayName;
        break;
    }
  }
}
